import { render, staticRenderFns } from "./ListaReveniriConfiguratorGard.vue?vue&type=template&id=5f56d87c&scoped=true"
import script from "./ListaReveniriConfiguratorGard.vue?vue&type=script&lang=js"
export * from "./ListaReveniriConfiguratorGard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56d87c",
  null
  
)

export default component.exports